import {
  createJsonStorageAdapter,
  createLanguageController,
  createSettingsStore,
  createThemeController,
  type AppCoreContext,
  type ThemeMode,
} from "@lunagoai/vue-app-core";
import { ref } from "vue";

export type AppLocale = "zh-TW" | "en";
type AppSettings = { theme: ThemeMode; locale: AppLocale };

const themeMode = ref<ThemeMode>("light");
const locale = ref<AppLocale>("zh-TW");

const settings = createSettingsStore<AppSettings>({
  defaults: { theme: "light" as ThemeMode, locale: "zh-TW" as AppLocale },
  storage: createJsonStorageAdapter<AppSettings>({ key: "logicore-cloudflare-settings" }),
});

themeMode.value = settings.settings.value.theme;
locale.value = settings.settings.value.locale;

const theme = createThemeController({ theme: themeMode, darkClass: "dark" });
const language = createLanguageController({
  currentLanguage: locale,
  availableLanguages: ["zh-TW", "en"] as const,
  setLanguage(value) {
    locale.value = value;
    settings.set("locale", value);
  },
});

theme.apply();

export const appCore: AppCoreContext = {
  settings,
  language,
  theme,
};
